// extracted by mini-css-extract-plugin
export default {"root":"BackToDashboard_root__G3oAY","chevron":"BackToDashboard_chevron__YTo1i"};